import { render, staticRenderFns } from "./KeysIcon.vue?vue&type=template&id=2e356654"
import script from "./KeysIcon.vue?vue&type=script&lang=js"
export * from "./KeysIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports